import apiSlice from "./ApiSlice";

const UserRoleApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllUserRoleData: builder.query({
      providesTags: ["user-role"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/user-role",
          method: "POST",
          body,
        };
      },
    }),

    // delete delivery date
    deleteUserRoleById: builder.mutation({
      invalidatesTags: ["user-role"],
      query: (id: any) => ({
        url: `/user-role/${id}`,
        method: "DELETE",
      }),
    }),
    // add delivery date
    addUserRole: builder.mutation({
      invalidatesTags: ["user-role"],
      query: (body) => ({
        url: `/user-role/add`,
        method: "POST",
        body,
      }),
    }),
    //get delivery date by Id
    getUserRoleById: builder.query({
      providesTags: ["user-role"],
      query: (id: string) => {
        return {
          url: `/user-role/${id}`,
          method: "GET",
        };
      },
    }),


    //get Payment Modes
    getAllUserRole: builder.query({
      providesTags: ["user-role"],
      query: () => {
        return {
          url: `/user-role`,
          method: "GET",
        };
      },
    }),

    // update delivery date
    updateUserRoleById: builder.mutation({
      invalidatesTags: ["user-role"],
      query: ({ body, id }) => ({
        url: `/user-role/${id}`,
        method: "PUT",
        body,
      }),
    }),

    // change status of delivery date
    changeStatusUserRoleById: builder.mutation({
      invalidatesTags: ["user-role"],
      query: ({ body, id }) => ({
        url: `/user-role/status-change/${id}`,
        method: "PUT",
        body,
      }),
    }),
     //get access module
    getUserAccess: builder.query({
      providesTags: ["user-role"],
      query: () => {
        return {
          url: `/access-module`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useGetAllUserRoleDataQuery,
  useDeleteUserRoleByIdMutation,
  useAddUserRoleMutation,
  useGetUserRoleByIdQuery,
  useUpdateUserRoleByIdMutation,
  useGetAllUserRoleQuery,
  useChangeStatusUserRoleByIdMutation,
  useGetUserAccessQuery
} = UserRoleApi;
